import { makeStyles } from "@material-ui/core";
import { Collection, Linked } from "@type-r/models"
import { InblockIcon } from "common/invoice-aging/iconography";
import { div, span, asCurrency, asTimelessDate } from "lqx-react"
import React from "react"
import { Payment } from "../api/payment";
import { PaymentVaultCard } from "../api/paymentVaultCard";
import { DigiCheckbox } from "../shared";

export const PaymentVaultCardRenderer = ($active: Linked<PaymentVaultCard>, actionButtonsProvider?, onClick?) =>
    ({ data, style, index }) => {
        const vaultCard: PaymentVaultCard = data.items[index];
        const payment: Payment = vaultCard.dataset;
        const isActive = $active.value == vaultCard;
        const InblockedIconClasses = useInblockedIconStyles();

        const onRowClicked = () => {
            $active.set(vaultCard);
            if(onClick) onClick(vaultCard);
        };

        return <ListRow style={style}>
            <Card {...{ active: isActive.toString(), onClick: onRowClicked }} key={payment.assetId}>
                <HeaderContainer>
                    {payment.isDigitized ? <InblockIcon src="/assets/images/inblock_logo.png" classes={InblockedIconClasses} /> : <Bullet />}
                    <State>{payment.state.name}  </State>
                    <PaymentNumber>{payment.referenceNumber ? payment.referenceNumber : ''}</PaymentNumber>
                </HeaderContainer>
                <TitleContainer>
                    <PayorAndPayee title={payment.debtorBankAccount.payor.name + ' - ' + payment.creditorBankAccount.payee.name}>
                        {payment.debtorBankAccount.payor.name} - {payment.creditorBankAccount.payee.name}
                    </PayorAndPayee>
                </TitleContainer>
                <ButtonsContainer>
                    {actionButtonsProvider ? actionButtonsProvider(vaultCard) : <ButtonsPlaceholder />}
                </ButtonsContainer>
                <Footer {...{ active: isActive.toString() }} >
                    <FooterProperty><FooterLabel>Value Date:</FooterLabel> {asTimelessDate(payment.assetPaymentDate)}</FooterProperty>
                    <FooterProperty><FooterLabel>Amount:</FooterLabel> {asCurrency(payment.paymentAmount)} </FooterProperty>
                    {!$active.value && <FooterProperty><FooterLabel>Currency:</FooterLabel> {payment.currency}</FooterProperty>}

                </Footer>
            </Card>
        </ListRow>
    }

const ListRow = div({
    display: 'grid',
    gridTemplateColumns: (props: any) => '1fr',
    paddingRight: '20px'
});

const Card = div({
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gridTemplateRows: 'auto 1fr auto',
    gridTemplateAreas: `"header buttons"
                        "title buttons"
                        "footer footer"`,
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
    width: '100%',
    height: '90px',
    background: '#FFFFFF',
    backgroundColor: (props: any) => props.active === 'true' ? '#F4FAFD' : '#FFFFFF',
    border: (props: any) => props.active === 'true' ? '1px solid #58C1EE' : '1px solid #F2F5F8'
});

const HeaderContainer = div({
    display: 'block',
    gridArea: 'header',
    gridAutoColumns: 'max-content',
    gridAutoFlow: 'column',
    gridGap: '5px',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '5px 10px'
});

const TitleContainer = div({
    gridArea: 'title',
    padding: "5px 10px",
    display: 'grid',
    alignItems: 'center',
    marginTop: '-5px'
});

const ButtonsContainer = div({
    display: 'block',
    marginTop: '4px'
});

const useInblockedIconStyles = makeStyles({
    root: {
        width: '15px',
        marginRight: '2px'
    }
});

const Footer = div({
    gridArea: 'footer',
    borderTop: '2px solid #F2F5F8',
    borderLeft: '1px solid #F2F5F8',
    borderRight: '1px solid #F2F5F8',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    height: '28px',
    overflow: 'hidden',
    borderBottomLeftRadius: '5px',
    borderBottomRightRadius: '5px',
    backgroundColor: (props: any) => props.active === 'true' ? '#E7F2F9' : '#F9FAFC',
    color: '#3E4B5F',
    display: 'flex',
    padding: '5px 10px',
    alignItems: 'center'
});

const FooterLabel = span({
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '15px',
    color: '#829AB0',
});

const State = span({
    color: '#63a9dc',
    fontFamily: 'Montserrat',
    fontSize: '11px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '13px',
    letterSpacing: '0px',
    textAlign: 'left',
    paddingLeft: '3px'
});

const PaymentNumber = span({
    color: '#bbc3cc',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    marginLeft: '5px'
});

const PayorAndPayee = span({
    color: 'black',
    fontFamily: 'Montserrat',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '16px',
    letterSpacing: '0px',
    textAlign: 'left',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    display: 'inline-block',
    maxWidth: '100%'
});

const Bullet = div({
    display: 'inline-block',
    width: '6px',
    height: '6px',
    background: '#4297D6',
    borderRadius: '11px',
    verticalAlign: 'middle'
});

const ButtonsPlaceholder = div({
    minHeight: '35px'
});

const FooterProperty = span({
    flex: '0 0 250px'
});
